import MessagingSidebarSettings from './messagingSidebarSettings';

export default MessagingSidebarSettings;
